import React from 'react';
import styled from 'styled-components';

const NavbarContainer = styled.nav`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const NavList = styled.ul`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 1rem;
`;

const NavItem = styled.li`
  font-size: 0.9rem;
  cursor: pointer;
  position: relative;
  padding: 0.5rem 0.75rem;
  color: ${props => props.active ? '#4285F4' : '#5f6368'};
  font-weight: ${props => props.active ? '500' : '400'};
  font-family: 'Inter', sans-serif;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: ${props => props.active ? '#4285F4' : 'transparent'};
    border-radius: 3px 3px 0 0;
    transition: background-color 0.2s ease;
  }
  
  &:hover {
    color: #4285F4;
  }
`;

const themes = [
  { id: 'apple', name: 'Apple' },
  { id: 'google', name: 'Google' },
  { id: 'twitter', name: 'Twitter' },
  { id: 'facebook', name: 'Facebook' }
];

function ThemeNavbar({ activeTheme, onThemeChange }) {
  return (
    <NavbarContainer>
      <NavList>
        {themes.map(theme => (
          <NavItem 
            key={theme.id}
            active={activeTheme === theme.id}
            onClick={() => onThemeChange(theme.id)}
          >
            {theme.name}
          </NavItem>
        ))}
      </NavList>
    </NavbarContainer>
  );
}

export default ThemeNavbar; 